import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const CopyCertificado = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.post(`/cuestionarios/copy/${params.id}`, params.data, {
            dataType: "json",
            hasFormData: false,
            hasCustomUrl: false,
        });
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        copyCertificadoMutation: mutation.mutate,
    };
}